var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"setting-item"},[_vm._v("训练时间:\n  ")]),_c('vue-numeric-input',{attrs:{"min":1,"max":10,"step":1},model:{value:(_vm.newVal),callback:function ($$v) {_vm.newVal=$$v},expression:"newVal"}}),_vm._v("\n  分\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }